/** Product mockup: 6 volumes, the session-plan tablet and the 5 bonus covers. */
export const heroImage = 'https://cdn.magicpatterns.com/uploads/bUmf4Su5wkUifmH8iarLwe/Sistema_visual_de_coaching_Futsal_360-Photoroom.webp';

/** Payment link used by every checkout button (the hero button scrolls to the offer instead). */
export const checkoutUrl = 'https://futsal-360.impultienda.ar/checkout';
export const brandName = 'FUTSAL 360 READY™';
export const price = '$27';
export const regularPrice = '$97';

/** Sent with every InitiateCheckout event. */
export const checkoutPixelParams = {
  content_name: 'Futsal 360 Ready',
  value: 27,
  currency: 'USD'
};
export interface Stat {
  value: string;
  label: string;
}
export const stats: Stat[] = [{
  value: '6',
  label: 'Visual coaching volumes'
}, {
  value: '72',
  label: 'Ready-to-run sessions'
}, {
  value: '5',
  label: 'Practical bonuses'
}];
export const heroBadges: string[] = ['100% in English', 'Instant access', 'Downloadable PDF', '7-day guarantee'];
export interface Testimonial {
  quote: string;
  role: string;
  country: string;
  /** False until the quote is replaced with a verified testimonial. */
  verified: boolean;
}
export const testimonials: Testimonial[] = [{
  quote: 'I used to save drills from everywhere and then waste time trying to connect them. Having the complete session already organized makes planning much simpler.',
  role: 'Club Futsal Coach',
  country: 'Australia',
  verified: false
}, {
  quote: 'The biggest difference is the clarity. The diagrams, progressions and coaching cues help me explain faster and keep the players moving.',
  role: 'Academy Futsal Coach',
  country: 'United Kingdom',
  verified: false
}];

/** The 6:00 PM scene in the problem section. */
export const arrivalLines: string[] = ['Your players are arriving.', 'Different levels.', 'Different technical needs.', 'Limited court space.', 'Limited equipment.', 'Limited preparation time.'];
export const sessionLines: string[] = ['One drill is too easy.', 'Another creates too much waiting.', 'Players crowd around the ball.', 'Passing angles disappear.', 'One player presses while the others stay behind.', 'Transitions are slow.', 'The progression is unclear.', 'You see a mistake but improvise the correction.', 'Some players understand the movement.', 'Others get lost.'];

/** The real cost of not having the right system. */
export type CostIcon = 'clock' | 'repeat' | 'hourglass' | 'route' | 'alert' | 'crowd' | 'unlink' | 'slow' | 'eye';
export interface Cost {
  title: string;
  detail: string[];
  icon: CostIcon;
  /** Accent tint for the card. */
  color: string;
}
export const costs: Cost[] = [{
  icon: 'clock',
  color: '#f97316',
  title: 'Hours of planning',
  detail: ['Your free time disappears before training even starts.']
}, {
  icon: 'repeat',
  color: '#a855f7',
  title: 'Same drills every week',
  detail: ['Players repeat activities without a clear development pathway.']
}, {
  icon: 'hourglass',
  color: '#f59e0b',
  title: 'Too much waiting',
  detail: ['One player works while the others stand and watch.']
}, {
  icon: 'route',
  color: '#3b82f6',
  title: 'No real progression',
  detail: ['You have drills, but not a coaching pathway.']
}, {
  icon: 'alert',
  color: '#ef4444',
  title: 'Improvised corrections',
  detail: ['You see the mistake but are not always sure what to change next.']
}, {
  icon: 'crowd',
  color: '#14b8a6',
  title: 'Players crowd the ball',
  detail: ['Everyone moves toward possession instead of creating useful space.']
}, {
  icon: 'unlink',
  color: '#ec4899',
  title: 'Disconnected pressing',
  detail: ['One player presses while the rest of the team stays disconnected.']
}, {
  icon: 'slow',
  color: '#22c55e',
  title: 'Slow transitions',
  detail: ['Players react too late when possession changes.']
}, {
  icon: 'eye',
  color: '#6366f1',
  title: 'Too much talking',
  detail: ['Players need to see the movement, not listen to a five-minute explanation.']
}];
export const finalCost = {
  title: 'Every session starts from zero',
  lead: 'And the same question comes back:',
  question: '“What am I going to coach today?”'
};

/** Offer card: what you get, shown above the price button. */
export const included: string[] = ['Step-by-step technique', 'Illustrated futsal drills', 'Futsal court diagrams', 'Visual progressions', 'Player movement sequences', 'Passing patterns', 'Pressing principles', 'Transition exercises', 'Common mistakes + quick fixes', '1v1 situations', '2v1 situations', '3v2 situations', '4v4 game situations', 'Mixed-level adaptations', 'Coaching cues', 'Session timelines', 'Printable coaching tools', '72 complete sessions', 'Instant PDF download'];

/** The difference: keep improvising vs. the system. */
export const differenceWithout: string[] = ['Hours searching for drills', 'No clear technical progression', 'Players waiting around', 'Players crowding the ball', 'Disconnected pressing', 'Slow transitions', 'Too much explanation', 'Random weekly planning', 'Every session starts from zero'];
export const differenceWith: string[] = ['5 minutes to organize your session', '72 complete sessions ready to use', 'Clear step-by-step progressions', 'More movement, less waiting', 'Visual futsal coaching system', 'Adaptations for different levels', 'Practical coaching cues', 'Pressing and transition structures', 'A repeatable structure for your training week'];